module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content"
  }, [_c('section', {
    staticClass: "text-section"
  }, [_c('h1', [_vm._v(_vm._s(_vm.greetingMessage))]), _vm._v(" "), _c('p', [_vm._v("\n      " + _vm._s(_vm.mainMessage) + "\n    ")])]), _vm._v(" "), _c('section', {
    staticClass: "icon-grid"
  }, [(_vm.check('USERS')) ? _c('div', {
    staticClass: "icon-wrapper"
  }, [_c('router-link', {
    staticClass: "pageLink",
    attrs: {
      "to": "/biomanager/users"
    }
  }, [_c('div', {
    staticClass: "icon-box"
  }, [_c('img', {
    staticClass: "turnIconWhite",
    attrs: {
      "alt": "icon",
      "src": require("../../../static/img/components-icons/users-three.svg")
    }
  })])]), _vm._v(" "), _c('span', {
    staticClass: "icon-description"
  }, [_vm._v("Usuários")])], 1) : _vm._e(), _vm._v(" "), (_vm.check('AGENTSUPT')) ? _c('div', {
    staticClass: "icon-wrapper"
  }, [_c('router-link', {
    staticClass: "pageLink",
    attrs: {
      "to": "/biomanager/agentsupdate"
    }
  }, [_c('div', {
    staticClass: "icon-box"
  }, [_c('img', {
    attrs: {
      "alt": "icon",
      "src": require("../../../static/img/components-icons/icone-pf.svg")
    }
  })])]), _vm._v(" "), _c('span', {
    staticClass: "icon-description"
  }, [_vm._v("Atualização de Agentes")])], 1) : _vm._e(), _vm._v(" "), (_vm.check('BIO')) ? _c('div', {
    staticClass: "icon-wrapper"
  }, [_c('router-link', {
    staticClass: "pageLink",
    attrs: {
      "to": "/biomanager/managepsbio"
    }
  }, [_c('div', {
    staticClass: "icon-box"
  }, [_c('img', {
    staticClass: "turnIconWhite",
    attrs: {
      "alt": "icon",
      "src": require("../../../static/img/reader-outline.svg")
    }
  })])]), _vm._v(" "), _c('span', {
    staticClass: "icon-description"
  }, [_vm._v("Consulta Biométrica Griaule")])], 1) : _vm._e(), _vm._v(" "), (_vm.check('BIO')) ? _c('div', {
    staticClass: "icon-wrapper"
  }, [_c('router-link', {
    staticClass: "pageLink",
    attrs: {
      "to": "/biomanager/consultaspid"
    }
  }, [_c('div', {
    staticClass: "icon-box"
  }, [_c('img', {
    staticClass: "turnIconWhite",
    attrs: {
      "alt": "icon",
      "src": require("../../../static/img/query_spid.svg")
    }
  })])]), _vm._v(" "), _c('span', {
    staticClass: "icon-description"
  }, [_vm._v("Consulta Biométrica SPID")])], 1) : _vm._e(), _vm._v(" "), (_vm.check('BIO')) ? _c('div', {
    staticClass: "icon-wrapper"
  }, [_c('router-link', {
    staticClass: "pageLink",
    attrs: {
      "to": "/biomanager/findpsbioorigin"
    }
  }, [_c('div', {
    staticClass: "icon-box"
  }, [_c('img', {
    staticClass: "turnIconWhite",
    attrs: {
      "alt": "icon",
      "src": require("../../../static/img/atom.svg")
    }
  })])]), _vm._v(" "), _c('span', {
    staticClass: "icon-description"
  }, [_vm._v("Consulta Origem IDN")])], 1) : _vm._e(), _vm._v(" "), (_vm.check('EXCBIO')) ? _c('div', {
    staticClass: "icon-wrapper"
  }, [_c('router-link', {
    staticClass: "pageLink",
    attrs: {
      "to": "/biomanager/delete"
    }
  }, [_c('div', {
    staticClass: "icon-box"
  }, [_c('img', {
    attrs: {
      "alt": "icon",
      "src": require("../../../static/img/components-icons/Icon-material-update.svg")
    }
  })])]), _vm._v(" "), _c('span', {
    staticClass: "icon-description"
  }, [_vm._v("Exclusão Biométrica")])], 1) : _vm._e(), _vm._v(" "), (_vm.check('AUDIT')) ? _c('div', {
    staticClass: "icon-wrapper"
  }, [_c('router-link', {
    staticClass: "pageLink",
    attrs: {
      "to": "/biomanager/subjectaudit"
    }
  }, [_c('div', {
    staticClass: "icon-box"
  }, [_c('img', {
    attrs: {
      "alt": "icon",
      "src": require("../../../static/img/components-icons/icone-bancos.svg")
    }
  })])]), _vm._v(" "), _c('span', {
    staticClass: "icon-description"
  }, [_vm._v("Auditoria de Sujeitos")])], 1) : _vm._e(), _vm._v(" "), (_vm.check('FRAUD')) ? _c('div', {
    staticClass: "icon-wrapper"
  }, [_c('router-link', {
    staticClass: "pageLink",
    attrs: {
      "to": "/biomanager/fraud"
    }
  }, [_c('div', {
    staticClass: "icon-box"
  }, [_c('img', {
    attrs: {
      "alt": "icon",
      "src": require("../../../static/img/components-icons/Group-282.svg")
    }
  })])]), _vm._v(" "), _c('span', {
    staticClass: "icon-description"
  }, [_vm._v("Análise de Fraude")])], 1) : _vm._e()])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-eb476b14"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/interfaces/views/Dashboard.vue
// module id = 271
// module chunks = 0